import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './components/ThemeProvider';
import { AuthProvider } from './components/AuthProvider';
import { PermissionsProvider } from './components/PermissionsProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/AppLayout';
import { Toaster } from './components/ui/sonner';
import LandingPage from './pages/LandingPage';
import ProductSelectorPage from './pages/ProductSelectorPage';
import DashboardPage from './pages/DashboardPage';
import TradeAnalyticsPage from './pages/TradeAnalyticsPage';
import InsurancePage from './pages/InsurancePage';
import MarketplacePage from './pages/MarketplacePage';
import UsagePage from './pages/UsagePage';
import IntegrationsPage from './pages/IntegrationsPage';
import AdminPage from './pages/admin/AdminPage';
import APIDocsPage from './pages/APIDocsPage';
import CommerceDashboardPage from './pages/CommerceDashboardPage';
import CategoryViewPage from './pages/CategoryViewPage';
import ProductViewPage from './pages/ProductViewPage';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AuthProvider>
          <PermissionsProvider>
            <Toaster richColors position="top-right" />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Product Selector - After Login */}
            <Route
              path="/selector"
              element={
                <ProtectedRoute>
                  <ProductSelectorPage />
                </ProtectedRoute>
              }
            />
            
            {/* Commerce Index Routes */}
            <Route
              path="/commerce"
              element={
                <ProtectedRoute>
                  <CommerceDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/commerce/category/:id"
              element={
                <ProtectedRoute>
                  <CategoryViewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/commerce/product/:id"
              element={
                <ProtectedRoute>
                  <ProductViewPage />
                </ProtectedRoute>
              }
            />
            
            {/* Maritime Pulse Routes (existing) */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <DashboardPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/trade-analytics"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <TradeAnalyticsPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/insurance"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <InsurancePage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/marketplace"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <MarketplacePage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/usage"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <UsagePage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/integrations"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <IntegrationsPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <AdminPage />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            
            {/* Public API Docs */}
            <Route path="/docs" element={<APIDocsPage />} />
            
            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </PermissionsProvider>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;